module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/new-logo-3-7c041f503962ff8907b1bb1b65c25db4.png";